import { MAX_LENGTH_255 } from '../../globalConstants'

import { validation } from './index'

export const validateEmail = validation.composeValidators(
  validation.isEmail(),
  validation.maxLength(MAX_LENGTH_255)
) as (value: string) => string | null
